import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

/**
 * Font Awesome Pro 7.3.0 — original Duotone Light globe (fadl).
 * Source: @fortawesome/fontawesome-pro/svgs/duotone-light/globe.svg
 * Copyright 2026 Fonticons, Inc. — https://fontawesome.com/license
 *
 * The full Pro package includes this artwork; our installed tree-shakable icon
 * packages only include other weights. Keep this single definition here so the
 * existing Angular icon component can render it without loading the full set.
 */
export const faGlobeLight: IconDefinition = {
  prefix: 'fadl',
  iconName: 'globe',
  icon: [
    512,
    512,
    [],
    'f0ac',
    [
      'M32.6 240l95.7 0C131 160.7 153.8 87.1 186.8 42.9 101.8 70.5 39.1 147.5 32.6 240zm0 32c6.5 92.5 69.2 169.5 154.2 197.1-33-44.2-55.8-117.8-58.5-197.1l-95.7 0zm127.7-32l191.4 0C349.6 183.2 336.5 130.5 317.5 91.9 295.4 47 271.5 32 256 32s-39.4 15-61.5 59.9c-19 38.6-32.1 91.3-34.2 148.1zm0 32c2.1 56.8 15.2 109.5 34.2 148.1 22.1 44.9 46 59.9 61.5 59.9s39.4-15 61.5-59.9c19-38.6 32.1-91.3 34.2-148.1l-191.4 0zM325.2 42.9c33 44.2 55.8 117.8 58.5 197.1l95.7 0c-6.5-92.5-69.2-169.5-154.2-197.1zm0 426.2c85-27.6 147.7-104.6 154.2-197.1l-95.7 0c-2.7 79.3-25.5 152.9-58.5 197.1z',
      'M317.5 420.1C295.4 465 271.5 480 256 480s-39.4-15-61.5-59.9c-19-38.6-32.1-91.3-34.2-148.1l191.4 0c-2.1 56.8-15.2 109.5-34.2 148.1zM351.7 240l-191.4 0c2.1-56.8 15.2-109.5 34.2-148.1 22.1-44.9 46-59.9 61.5-59.9s39.4 15 61.5 59.9c19 38.6 32.1 91.3 34.2 148.1zm32 32l95.7 0c-6.5 92.5-69.2 169.5-154.2 197.1 33-44.2 55.8-117.8 58.5-197.1zm95.7-32l-95.7 0c-2.7-79.3-25.5-152.9-58.5-197.1 85 27.6 147.7 104.6 154.2 197.1zm-351.2 0l-95.7 0c6.5-92.5 69.2-169.5 154.2-197.1-33 44.2-55.8 117.8-58.5 197.1zM32.6 272l95.7 0c2.7 79.3 25.5 152.9 58.5 197.1-85-27.6-147.7-104.6-154.2-197.1zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512z',
    ],
  ],
};
